const DESTINO_POR_EMPRESA = {
  'mov-fibra': 'XT',
  'xt-fibra': 'MOV',
};

export const obterEmpresaConsultada = (companyContext) => {
  if (companyContext?.isGroup || companyContext?.isConsolidated) return null;
  return DESTINO_POR_EMPRESA[companyContext?.companies?.[0]?.slug] || null;
};
